// extracted by mini-css-extract-plugin
module.exports = {"optionalButton":"OptionalBottomNavButtons_optionalButton__2lhpN","backButton":"OptionalBottomNavButtons_backButton__T2FsU"};